import React from 'react';
import { Button, Toolbar } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useUserRolePermissions } from 'hooks';
import { useNavigate } from 'react-router-dom';

import { func } from 'prop-types';

const icon = {
  '& >*:nth-of-type(1)': {
    fontSize: 24,
  },
  margin: 0,
};

const MobileNav = ({ setMobileFilterDrawerOpen }) => {
  const { isProductLoadingManage, isSupplier } = useUserRolePermissions();
  const navigate = useNavigate();

  return (
    <Toolbar
      disableGutters
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 1,
        marginTop: 7,
        position: 'fixed',
        width: '100%',
        zIndex: 2,
      }}
      variant="dense"
    >
      {isProductLoadingManage && isSupplier && (
        <Button
          onClick={() => navigate('./create/step1')}
          startIcon={<AddRoundedIcon />}
          sx={{
            '& .MuiButton-startIcon': icon,
            ':hover': {
              boxShadow: 'none',
            },
            borderRadius: 'unset',
            boxShadow: 'none',
            flex: 1,
            fontFamily: 'Gothic A1',
            fontSize: 16,
            height: 56,
            letterSpacing: 0.5,
            padding: theme => theme.spacing(0, 2),
          }}
        >
          Add New
        </Button>
      )}
      <Button
        endIcon={<ChevronRightRoundedIcon />}
        onClick={() => setMobileFilterDrawerOpen(true)}
        sx={{
          '& .MuiButton-endIcon': icon,
          ':hover': {
            backgroundColor: 'surface.white',
            boxShadow: 'none',
            color: 'secondary.main',
          },
          backgroundColor: 'surface.white',
          borderRadius: 'unset',
          boxShadow: 'none',
          color: 'secondary.main',
          flex: 1,
          fontFamily: 'Gothic A1',
          fontSize: 16,
          height: 56,
          letterSpacing: 0.5,
          padding: theme => theme.spacing(0, 2),
        }}
      >
        Filters
      </Button>
    </Toolbar>
  );
};

MobileNav.propTypes = {
  setMobileFilterDrawerOpen: func.isRequired,
};

export default MobileNav;
